<template>
	<div class="">
		<a-spin :spinning="loading">
			<div class="flex space alcenter">
				<div class="ft20 cl-main ftw600">{{getTitle}}</div>
				<a-button @click="$router.go(-1)">返回</a-button>
			</div>
			
			<div class="mt20 bg-w pd40">
				<div style="width: 1000px;">
					<a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
						<a-form-model-item required label="课程名称" help="30字以内">
							<a-input v-model="form.course_name" :maxLength="30" placeholder="输入课程名称" style="width: 480px;"></a-input>
						</a-form-model-item>
						
						<a-form-model-item required label="课程分类" >
							<a-select v-model="form.course_type_id" style="width:200px" >
							    <a-select-option :value="0">
							        选择分类
							    </a-select-option>
								<a-select-option :value="item.course_type_id" v-for="(item,index) in type_list">
								    {{item.name}}
								</a-select-option>
							</a-select>
						</a-form-model-item>

						<a-form-model-item required label="市场价">
							<a-input-number v-model="form.market_price"  :formatter="value => `${value}元`" placeholder="请输入" :precision="2" :min="0" style="width: 120px;"/>
						</a-form-model-item>

						<a-form-model-item required label="现价">
							<a-input-number v-model="form.price"  :formatter="value => `${value}元`" placeholder="请输入" :precision="2" :min="0" style="width: 120px;"/>
						</a-form-model-item>

						<a-form-model-item required label="课程简介">
							<a-input v-model="form.info" placeholder="请输入简介" type="textarea" :maxlength="50" style="width: 480px;"></a-input>
						</a-form-model-item>

						<a-form-model-item required label="封面图" >
							<div class="ft12 ftw400 cl-notice">建议上传300x240px</div>
							<div class="mt10 ml20">
								<upload-img v-model="form.cover_img"></upload-img>
							</div>
						</a-form-model-item>

						<a-form-model-item label="时间信息">
							<a-input v-model="form.time_info" placeholder="请输入" type="textarea" :maxlength="50" style="width: 480px;"></a-input>
						</a-form-model-item>

						<a-form-model-item label="地点信息">
							<a-input v-model="form.address_info" placeholder="请输入" type="textarea" :maxlength="50" style="width: 480px;"></a-input>
						</a-form-model-item>

						<!-- <a-form-model-item required label="所属门店">
							<a-select style="width: 200px;" v-model="form.mendian_id">
								<a-select-option :value="0">请选择</a-select-option>
								<a-select-option v-for="(item,index) in mendians" :key="index" :value="item.mendian_id">{{item.name}}</a-select-option>
							</a-select>
						</a-form-model-item> -->

						<a-form-model-item label="库存">
							<a-input-number v-model="form.stock"  :formatter="value => `${value}`" placeholder="请输入" :precision="0" :min="0" style="width: 120px;"/>
						</a-form-model-item>

						<a-form-model-item required label="开始时间">
							<a-date-picker
								v-model="form.start_time"
								format="YYYY-MM-DD HH:mm:ss"
  								valueFormat="YYYY-MM-DD HH:mm:ss"
								placeholder="开始时间"
								style="width: 240px"
							/>
						</a-form-model-item>
	
						<a-form-model-item required label="结束时间">
							<a-date-picker
								v-model="form.end_time"
								format="YYYY-MM-DD HH:mm:ss"
  								valueFormat="YYYY-MM-DD HH:mm:ss"
								placeholder="结束时间"
								style="width: 240px"
							/>
						</a-form-model-item>

						<a-form-model-item label="置顶" >
							<a-radio-group v-model="form.is_top">
								<a-radio :value="0">否</a-radio>
								<a-radio :value="1">是</a-radio>
							</a-radio-group>
						</a-form-model-item>

						<a-form-model-item label="热门" >
							<a-radio-group v-model="form.is_hot">
								<a-radio :value="0">否</a-radio>
								<a-radio :value="1">是</a-radio>
							</a-radio-group>
						</a-form-model-item>

						<a-form-model-item label="新品" >
							<a-radio-group v-model="form.is_new">
								<a-radio :value="0">否</a-radio>
								<a-radio :value="1">是</a-radio>
							</a-radio-group>
						</a-form-model-item>

						<a-form-model-item required label="排序" help="越小越靠前">
							<a-input v-model="form.sort"  :maxLength="10" placeholder="输入序号" style="width: 100px;"></a-input>
						</a-form-model-item>

						<a-form-model-item required label="状态" >
							<a-select v-model="form.status" style="width: 120px;">
								<a-select-option :value="0">请选择</a-select-option>
								<a-select-option :value="1">正常</a-select-option>
								<a-select-option :value="2">失效</a-select-option>
							</a-select>
						</a-form-model-item>

						<a-form-model-item required label="轮播图" >
							<div class="ft12 ftw400 cl-notice">最多可传5张，建议上传750x750px</div>
							<div class="mt10 ml20">
								<upload-list v-model="form.rotation"></upload-list>
							</div>
						</a-form-model-item>
						
						<a-form-model-item label="详情" required class="mt20">
							 <html-edit v-model="form.detail"></html-edit>
						</a-form-model-item>
						
						<a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
						      <a-button type="primary" @click="onSubmit" :loading="confirmLoading">
						        确定保存
						      </a-button>
						</a-form-model-item>
					</a-form-model>	
					
				</div>
			</div>
		</a-spin>
	</div>
</template>

<script>
	import uploadImg from '../../components/upload/upload.vue';
	import uploadList from '../../components/upload/list.vue';
	import  htmlEdit from '../../components/html.vue';

	export default{
		components:{
			uploadImg,
			uploadList,
			htmlEdit
		},
		data(){
			return {
				loading:false,
				confirmLoading:false,
				labelCol: { span: 4 },
			    wrapperCol: { span: 20 },
				course_id:0,
				type_list:[],
				form: {
					mendian_id:0,
					course_name:'',
					course_type_id:0,
					market_price:'',
					price:'',
					cover_img:'',
					info:'',
					time_info:'',
					address_info:'',
					stock:0,
					status:1,
					start_time:'',
					end_time:'',
					is_top:0,
					is_hot:0,
					is_new:0,
					sort:0,
					rotation:[],
					detail:'',
				},
				mendians: [],
			}
		},
		created() {
			if (!this.$route.query.id) {
				this.course_id=0;
			} else {
				this.course_id = parseInt(this.$route.query.id);
			}
			if(this.$route.query.template_id){
				this.form.template_id =  this.$route.query.template_id
				this.getTemplateById()
			}
			this.loaddata();
			this.getMendians();
		},
		computed:{
			getTitle(){
				if(this.course_id==0){
					return '添加课程';
				}else{
					return '编辑课程';
				}
			}
		},
		methods:{
			loaddata(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/showCourse',{
					course_id:this.course_id
				}).then(res=>{
					if(res.detail){
						this.form=res.detail;
					}
					this.type_list=res.type_list;
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
					this.$router.go(-1);
				})
			},
			getMendians(){
				this.$http.api('admin/getAllMendian').then(res=>{
					this.mendians = res.mendian;
				}).catch(res=>{
					console.log(res);
				});
			},
			getTemplateById() {
				this.$http.api('admin/showTemplate',{
					template_id:this.form.template_id
				}).then(res=>{
					if(res.detail){
						this.form.full_name = res.detail.full_name
						this.form.abbreviation = res.detail.abbreviation
						this.form.course_type_id = res.detail.course_type_id
						this.form.info = res.detail.info
						this.form.cover_img = res.detail.cover_img
						this.form.market_price = res.detail.market_price
						this.form.expert_price = res.detail.expert_price
						this.form.master_price = res.detail.master_price
						this.form.expert_price = res.detail.expert_price
						this.form.expert_price = res.detail.expert_price
					}
				})
			},
			onSubmit() {
				if(this.confirmLoading==true) return;
				this.confirmLoading=true;
				this.$http.api('admin/saveCourse',{
					course_id:this.course_id,
					course_name: this.form.course_name,
					course_type_id: this.form.course_type_id,
					info:this.form.info,
					cover_img: this.form.cover_img,
					market_price: this.form.market_price,
					price:this.form.price,
					time_info:this.form.time_info,
					address_info:this.form.address_info,
					stock:this.form.stock,
					status:this.form.status,
					start_time:this.form.start_time,
					end_time:this.form.end_time,
					mendian_id:this.form.mendian_id,
					is_top:this.form.is_top,
					is_hot:this.form.is_hot,
					is_new:this.form.is_new,
					sort:this.form.sort,
					rotation: this.form.rotation,
					detail:this.form.detail,
				}).then(res=>{
					this.$message.success('保存成功',1,()=>{
						this.confirmLoading=false;
						this.$router.go(-1);
					});
				}).catch(res=>{
					console.log(res);
					this.confirmLoading=false;
				})
			},
			
		}
	}
</script>

<style>
	
</style>